import React, { useState } from 'react';
import { connect } from 'react-redux';
import { Redirect, useLocation } from 'react-router-dom';
import { AppState } from '../../reducers';
import { isLogged } from '../../selectors';
import userManager from '../../utilities/userManager';
import LoginForm, { getLoginKind, LoginCallbackState, LoginKind } from './LoginForm';
import { loginPathPrefix } from './routes';

function doLogin(loginKind: LoginKind, returnUrl?: string | null) {
    let path = window.location.pathname.replace(loginPathPrefix, '');
    if (returnUrl) {
        path = returnUrl;
    }
    const ext: LoginCallbackState = {
        state: {
            kind: loginKind,
            path: path,
        },
    };
    return userManager.signinRedirect(ext);
}

const Login: React.FC<{ isLogged: boolean; }> = ({ isLogged }) => {
    const [loginInProgress, setLoginInProgress] = useState(false);
    const loginKind = getLoginKind();
    const location = useLocation();

    const params = new URLSearchParams(location.search);
    const returnUrl = params.get('returnUrl');

    React.useEffect(() => {
        if (isLogged || loginKind !== LoginKind.INITIAL) return;
        setLoginInProgress(true);
        doLogin(loginKind, returnUrl)
            .catch(e => {
                console.error(e);
                setLoginInProgress(false);
            });
    }, [isLogged, loginKind, returnUrl]);

    if (isLogged) {
        if (returnUrl) {
            return <Redirect to={returnUrl} />;
        }
        const redirectPath = window.location.pathname.replace(loginPathPrefix, '');
        return <Redirect to={redirectPath} />;
    }

    const handleLogin: React.FormEventHandler<HTMLFormElement> = async (e) => {
        e.preventDefault();
        setLoginInProgress(true);
        doLogin(LoginKind.REGULAR, returnUrl)
            .catch(e => {
                console.error(e);
                setLoginInProgress(false);
            });
    };

    return (
        <LoginForm loading={loginInProgress} onSubmit={handleLogin} />
    );
};

export default connect(
    (state: AppState) => ({
        isLogged: isLogged(state),
    }),
)(Login);
